import * as React from "react";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input,
} from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

import { useWorkspaceContext } from "../context";



export default function LayerSelector() {
    const [isOpen, setOpen] = React.useState(false);

    const workspaceContext = useWorkspaceContext();
    let layers = workspaceContext.data ? workspaceContext.data.layers : [];

    // const { layers } =
    // console.log("Workspace data", workspaceContext.data);
    return (
        <Dropdown
            isOpen={isOpen}
            toggle={() => setOpen(st => !st)}
            direction="down"
        >
            <DropdownToggle caret>
                <FontAwesomeIcon icon={faLayerGroup} />{" "}
                <span
                    style={{
                        // minWidth: 100,
                        // maxWidth: 200,
                        width: 150,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        margin: "inherit",
                        lineHeight: "1.3em",
                        height: "1em",
                    }}
                    className="text-start m-0 p-0"
                >
                    {"Some layer name"
                    || <span className="text-muted">Untitled workspace</span>}
                    {" "}
                </span>
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem tag={Link} to="./new-layer">
                    Create new layer...
                </DropdownItem>
                <DropdownItem divider />

                {layers.map(layer => (
                    <DropdownItem key={layer.id}>
                        {layer.displayName}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
}
